module.exports = __webpack_public_path__ + "static/music-box-poster-81089fa4caba07ad5709b9b9c0ef2f6d.jpg";